import { getCompanyUsers } from "actions/AccountManagementActions";
import { useEffect } from "react";
import { FieldForm } from "../Input";
import { useDispatch, useSelector } from "react-redux";
import { useCurrentCompany, useCurrentUser } from "hooks/auth";

export default function UserSelectDropDown({
	name,
	label,
	placeholder,
	description,
	rfx,
}) {
	const { currentUser } = useCurrentUser();
	const company = useCurrentCompany();
	const companyUsers = useSelector((state) =>
		state?.accountManagement?.companyUsers?.map((user) => {
			const isYou = currentUser?.id === user.id;
			const isProjectLead = rfx?.rfxLead?.id === user.id;
			return {
				id: user?.id,
				label: `${user?.full_name} ${isYou && isProjectLead ? "(Project Lead - You)" : isProjectLead ? "(Project Lead)" : isYou ? "(You)" : ""}`,
				value: user?.id,
			};
		})
	);
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(getCompanyUsers(company?.id));
		
	}, []);

	return (
		<FieldForm
			label={label}
			placeholder={placeholder}
			name={name}
			description={description}
			type="select"
			required={true}
			options={companyUsers}
			isSearchable={false}
			testId={"project-lead"}
		/>
	);
}
